import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MatTableDataSource, MAT_DIALOG_DATA } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { GroupNames } from '../models/TasksAndGroups';
import { DeleteDocumentComponent } from '../PatientChart/Document/delete-document/delete-document.component';
import { TasksAndGroupsService } from '../Services/TaskAndGroup/tasks-and-groups.service';

export class ConfirmDialogModel {
  constructor(public title: string, public message: string) {
  }
}

@Component({
  selector: 'app-group-name-dialog',
  templateUrl: './group-name-dialog.component.html',
  styleUrls: ['./group-name-dialog.component.css']
})
export class GroupNameDialogComponent implements OnInit {
  GroupNameForm: FormGroup;
  displayedColumns: string[] = ['groupName', 'description', 'action'];
  dataSource = new MatTableDataSource();
  public show: boolean = false;
  public message: string = '';

  constructor(public dialogRef: MatDialogRef<GroupNameDialogComponent>
    , private fb: FormBuilder
    , private toastr: ToastrService
    , public dialog: MatDialog
    , private _taskandgroupservice: TasksAndGroupsService, private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.GroupNameForm = this.fb.group({
      groupName: [''],
      description: [''],
    });
    this.getSavedCategoryNames();
  }
  showInfo() {
    this.show = !this.show;
    this.GroupId = 0;
    this.message = "";
    this.groupName = '';
    this.GroupNameForm.patchValue({
      groupName: '',
      description: ''
    });
  }

  onNoClick(): void {
    this.show = !this.show;
    this.message = "";
    this.GroupId = 0;
    this.GroupNameForm.patchValue({
      groupName: '',
      description: ''
    });
  }
  onClearClick() {
    this.dialogRef.close();
  }

  GroupNamesList: GroupNames[] = [];
  getSavedCategoryNames() {
    this.spinner.show();
    this._taskandgroupservice.GetAllGroupNames('AddGroup').subscribe(data => {
      this.dataSource.data = data;
      this.GroupNamesList = data;
      this.spinner.hide();
    }, (err: any) => {
      console.log(err)
      this.spinner.hide();
    });
  }

  DelGroupName(ele: GroupNames) {
    const message = "Are you sure to delete this " + ele.GroupName + "? ";
    const dialogData = new ConfirmDialogModel('Confirm Action', message);
    const dialogRef = this.dialog.open(DeleteDocumentComponent, {
      maxWidth: '400px',
      height: '130px',
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this._taskandgroupservice.DeleteGroupName(ele).subscribe(msg => {
          this.toastr.success(msg);
          this.getSavedCategoryNames();
        });
      }
    });
  }

  GroupId: number = 0
  groupName: string = "";
  onGroupNameclick(ele: GroupNames) {
    this.message = "";
    this.GroupId = ele.Id;
    this.show = true;
    this.GroupNameForm.patchValue({
      groupName: ele.GroupName,
      description: ele.Description,
    });
    this.groupName = ele.GroupName;
  }
  GroupInfo: GroupNames
  SaveGroupName() {
    if (this.GroupNameForm.value.groupName != "") {
      if (this.groupName.toLowerCase() == this.GroupNameForm.value.groupName.toLowerCase()) {
      } else {
        let existList = this.GroupNamesList.filter(x => x.GroupName.toLowerCase() == this.GroupNameForm.value.groupName.toLowerCase().trim());
        if (existList.length > 0) {
          this.message = "This Group Name Already Exist.";
          return;
        }
      }


      this.GroupInfo = {} as GroupNames;
      this.GroupInfo.GroupName = this.GroupNameForm.value.groupName;
      this.GroupInfo.Description = this.GroupNameForm.value.description;
      this.GroupInfo.IsActive = true;
      this.GroupInfo.CreatedBy = sessionStorage.getItem("userId");
      this.GroupInfo.FacilityId = sessionStorage.getItem("FacilityId");
      this.GroupInfo.CreatedOn = new Date();
      if (this.GroupId != 0) {
        this.GroupInfo.Id = this.GroupId
      }
      this.spinner.show();
      this._taskandgroupservice.SaveOrUpdateGroupName(this.GroupInfo).subscribe((results: any) => {
        this.toastr.success(results);
        //   this.GroupInfo.Id=0;
        this.show = false;
        this.message = '';
        this.GroupId = 0;
        this.GroupNameForm.patchValue({
          groupName: '',
          description: '',
        });
        this.spinner.hide();
        this.getSavedCategoryNames();
      }, (err: any) => {
        console.log(err)
        this.spinner.hide();
      });

    } else {
      this.spinner.hide();
      this.message = 'Please Enter Group Name.'
    }
  }

  avoidspaceatfirst(event) {
    if (event.which === 32 && event.target.selectionStart === 0) {
      return false;
    } else {
      let input = String.fromCharCode(event.charCode);
      const reg = /(^(?!.*\\).*$)/g;
      if (!reg.test(input)) {
        event.preventDefault();
      }
    }
  }
}
